function c(e, o) {
  const t = [];
  for (let n = 0; n <= o.length; n++)
    t[n] = [n];
  for (let n = 0; n <= e.length; n++)
    t[0][n] = n;
  for (let n = 1; n <= o.length; n++)
    for (let r = 1; r <= e.length; r++)
      o.charAt(n - 1) === e.charAt(r - 1) ? t[n][r] = t[n - 1][r - 1] : t[n][r] = Math.min(
        t[n - 1][r - 1] + 1,
        // substitution
        t[n][r - 1] + 1,
        // insertion
        t[n - 1][r] + 1
        // deletion
      );
  return t[o.length][e.length];
}
function f(e, o, t = 3) {
  let n = null, r = t + 1;
  for (const i of o) {
    const s = c(
      e.toLowerCase(),
      i.toLowerCase()
    );
    s < r && (r = s, n = i);
  }
  return r <= t ? n : null;
}
function u(e, o = 5) {
  if (e.length === 0) return "none";
  if (e.length <= o)
    return e.join(", ");
  const t = e.slice(0, o), n = e.length - o;
  return `${t.join(", ")} (+${n} more)`;
}
function $(e, o) {
  const t = f(e, o);
  let n = `Unknown element <${e}>`;
  return t && (n += ` - did you mean <${t}>?`), o.length > 0 && (n += `
  Available recipes: ${u(o)}`), n;
}
function g(e, o, t, n) {
  const r = f(e, t);
  let i = `[${o}] Unknown attribute "${e}"`;
  return r && (i += ` - did you mean "${r}"?`), n && n.length > 0 && (i += `
  Shorthands: ${u(n)}`), t.length > 0 && (i += `
  Available: ${u(t)}`), e.includes("-") && !r && (i += `
  Note: Custom components must be registered before creating the Game instance`), i;
}
function l(e, o, t, n) {
  const r = n ? f(o, n) : null;
  let i = `[${e}.${o}] ${t}`;
  return r && (i += ` - did you mean "${r}"?`), n && n.length > 0 && (i += `
  Available: ${u(n)}`), i;
}
function m(e, o, t, n) {
  return `[${e}] Syntax error in "${o}" - ${n}
  Expected: ${t}`;
}
function h(e, o, t, n) {
  const r = f(t, n);
  let i = `[${e}.${o}] Invalid value "${t}"`;
  return r && (i += ` - did you mean "${r}"?`), i += `
  Valid options: ${u(n)}`, i;
}
function d(e, o, t, n) {
  return `[${e}.${o}] Type mismatch - expected ${t}, got ${n}`;
}
function y(e, o, t, n) {
  return `[${e}.${o}] Wrong number of values - expected ${t}, got ${n}`;
}
function E(e) {
  const o = [];
  for (const t in e) {
    if (typeof e[t] == "function" || t.startsWith("_")) continue;
    const n = t.replace(/([A-Z])/g, "-$1").toLowerCase();
    o.push(n);
  }
  return o;
}
export {
  f as findSimilar,
  h as formatEnumError,
  u as formatOptions,
  l as formatPropertyError,
  m as formatSyntaxError,
  d as formatTypeMismatch,
  g as formatUnknownAttribute,
  $ as formatUnknownElement,
  y as formatValueCountError,
  E as getComponentProperties
};
//# sourceMappingURL=diagnostics.js.map
